import {
  parse,
  stringify,
  StringifyOptions,
  stringifyUrl as _stringifyUrl,
  UrlObject,
} from "query-string";

const DEFAULT_SETTINGS = {
  arrayFormat: "comma",
} as const as StringifyOptions;

export function stringifyUrl(url: UrlObject, settings = {}) {
  return _stringifyUrl(url, { ...DEFAULT_SETTINGS, ...settings });
}

export function parseQuery<T>(query: string, settings = {}) {
  return parse(query, {
    ...DEFAULT_SETTINGS,
    parseBooleans: true,
    parseNumbers: true,
    ...settings,
  }) as T;
}

export function stringifyQuery(obj: Record<string, unknown>, settings = {}) {
  return stringify(obj, { ...DEFAULT_SETTINGS, ...settings });
}
